import React, { useState } from "react";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
const EventSchemaForm = () => {
  const [formData, setFormData] = useState({
    eventName: "",
    eventDescription: "",
    imageUrl: "",
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    eventStatus: "EventScheduled",
    attendanceMode: "OnlineEventAttendanceMode",
    performerType: "Person",
    performerName: "",
    ticketTypes: [{ name: "", price: "", currency: "" }],
  });

  const [schema, setSchema] = useState({
    "@context": "https://schema.org",
    "@type": "Event",
    "name": "Sample Event",
    "description": "Sample description for an event.",
    "image": "https://example.com/image.jpg",
    "startDate": "2025-01-01T10:00:00",
    "endDate": "2025-01-01T12:00:00",
    "eventStatus": "EventScheduled",
    "eventAttendanceMode": "OnlineEventAttendanceMode",
    "performer": {
      "@type": "Person",
      "name": "John Doe",
    },
    "offers": [
      {
        "@type": "Offer",
        "name": "General Admission",
        "price": "10",
        "priceCurrency": "USD",
      },
    ],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleTicketChange = (index, field, value) => {
    const updatedTickets = formData.ticketTypes.map((ticket, i) =>
      i === index ? { ...ticket, [field]: value } : ticket
    );
    setFormData({ ...formData, ticketTypes: updatedTickets });
  };

  const addTicketType = () => {
    setFormData({
      ...formData,
      ticketTypes: [...formData.ticketTypes, { name: "", price: "", currency: "" }],
    });
  };

  const removeTicketType = (index) => {
    setFormData({
      ...formData,
      ticketTypes: formData.ticketTypes.filter((_, i) => i !== index),
    });
  };

  const generateSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": "Event",
      "name": formData.eventName,
      "description": formData.eventDescription,
      "image": formData.imageUrl,
      "startDate": `${formData.startDate}T${formData.startTime}`,
      "endDate": `${formData.endDate}T${formData.endTime}`,
      "eventStatus": formData.eventStatus,
      "eventAttendanceMode": formData.attendanceMode,
      "performer": {
        "@type": formData.performerType,
        "name": formData.performerName,
      },
      "offers": formData.ticketTypes.map((ticket) => ({
        "@type": "Offer",
        "name": ticket.name,
        "price": ticket.price,
        "priceCurrency": ticket.currency,
      })),
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedSchema = generateSchema();
    setSchema(updatedSchema);
    toast.success("Event Schema updated successfully!");
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify(schema, null, 2)).then(() => {
      toast.info("JSON-LD copied to clipboard!");
    });
  };
  const deleteSchema = () => {
    setSchema({
      "@context": "https://schema.org",
      "@type": "Event",
      "name": "Sample Event",
      "description": "Sample description for an event.",
      "image": "https://example.com/image.jpg",
      "startDate": "2025-01-01T10:00:00",
      "endDate": "2025-01-01T12:00:00",
      "eventStatus": "EventScheduled",
      "eventAttendanceMode": "OnlineEventAttendanceMode",
      "performer": {
        "@type": "Person",
        "name": "John Doe",
      },
      "offers": [
        {
          "@type": "Offer",
          "name": "General Admission",
          "price": "10",
          "priceCurrency": "USD",
        },
      ],
    });
    toast.warning("Schema reset to dummy data!");
  };
  
  return (
    <div className="container mt-5">
      <ToastContainer />
   
      <div className="row">
        {/* Form Section */}
        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Enter Event Details</h5>
            <form onSubmit={handleSubmit}>
              {/* Event Name and Description */}
              <div className="row mb-3">
                <div className="col-md-12">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="eventName"
                    value={formData.eventName}
                    onChange={handleInputChange}
                    placeholder="Enter event name"
                  />
                </div>
                <div className="col-md-12">
                  <label className="form-label">Event Description</label>
                  <textarea
                    className="form-control"
                    name="eventDescription"
                    value={formData.eventDescription}
                    onChange={handleInputChange}
                    placeholder="Enter event description"
                    rows="3"
                  ></textarea>
                </div>
              </div>

              {/* Image URL */}
              <div className="mb-3">
                <label className="form-label">Image URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="imageUrl"
                  value={formData.imageUrl}
                  onChange={handleInputChange}
                  placeholder="Enter image URL"
                />
              </div>

              {/* Start and End Dates */}
              <div className="row mb-3">
                <div className="col-md-3">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Start Time</label>
                  <input
                    type="time"
                    className="form-control"
                    name="startTime"
                    value={formData.startTime}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">End Time</label>
                  <input
                    type="time"
                    className="form-control"
                    name="endTime"
                    value={formData.endTime}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* Performer */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Performer Type</label>
                  <select
                    name="performerType"
                    className="form-select"
                    value={formData.performerType}
                    onChange={handleInputChange}
                  >
                    <option value="Person">Person</option>
                    <option value="Organization">Organization</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Performer Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="performerName"
                    value={formData.performerName}
                    onChange={handleInputChange}
                    placeholder="Enter performer name"
                  />
                </div>
              </div>

              {/* Ticket Types */}
              <div className="mb-3">
                <label className="form-label">Add Ticket Types</label>
                {formData.ticketTypes.map((ticket, index) => (
                  <div key={index} className="row mb-2 align-items-center">
                    <div className="col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Ticket Name"
                        value={ticket.name}
                        onChange={(e) =>
                          handleTicketChange(index, "name", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Price"
                        value={ticket.price}
                        onChange={(e) =>
                          handleTicketChange(index, "price", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <select
                        className="form-select"
                        value={ticket.currency}
                        onChange={(e) =>
                          handleTicketChange(index, "currency", e.target.value)
                        }
                      >
                        <option value="USD">USD</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                      </select>
                    </div>
                    <div className="col-md-2 text-end">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeTicketType(index)}
                      >
                        ✖
                      </button>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addTicketType}
                >
                  + Add Ticket Type
                </button>
              </div>

              {/* Submit Button */}
              <div className="text-center">
                <button type="submit" className="btn btn-success w-100">
                  Generate Schema
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* JSON-LD Preview Section */}
        <div className="col-lg-6">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Generated JSON-LD</h5>
            <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={copyToClipboard}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
            <div className="bg-light p-3 rounded border">
              <JSONPretty id="json-pretty" data={schema}></JSONPretty>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventSchemaForm;
